import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Today from "@/pages/Today";
import Performance from "@/pages/Performance";
import Digest from "@/pages/Digest";
import Admin from "@/pages/Admin";
import TopNav from "@/components/TopNav";
import SignInGate from "@/components/SignInGate";
import AlertsBanner from "@/components/AlertsBanner";
import { useAuth, useAuthBootstrap } from "@/lib/auth";

function App() {
    const { ready, error } = useAuthBootstrap();
    const { authenticated, loading, me } = useAuth();

    if (!ready || loading) {
        return (
            <div className="App min-h-screen flex items-center justify-center text-[#52525b] mono text-sm">
                Loading…
            </div>
        );
    }

    if (!authenticated) {
        return (
            <div className="App brutal-scope">
                <SignInGate reason={error} />
                <Toaster position="bottom-right" />
            </div>
        );
    }

    const isManagerOrAdmin = me?.role === "admin" || me?.role === "manager";
    const isAdmin = me?.role === "admin";

    return (
        <div className="App brutal-scope">
            <BrowserRouter>
                <TopNav isManagerOrAdmin={isManagerOrAdmin} isAdmin={isAdmin} />
                <AlertsBanner />
                <Routes>
                    <Route path="/" element={<Navigate to="/today" replace />} />
                    <Route path="/today" element={<Today />} />
                    {isManagerOrAdmin && (
                        <Route path="/performance" element={<Performance />} />
                    )}
                    {isManagerOrAdmin && (
                        <Route path="/digest" element={<Digest />} />
                    )}
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/search" element={<Home />} />
                    <Route path="*" element={<Navigate to="/today" replace />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="bottom-right"
                toastOptions={{
                    style: {
                        borderRadius: 0,
                        border: "1px solid #000",
                        fontFamily: "IBM Plex Sans, sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
